<template>
  <div class="overFlow">
    <div class="search flex">
      <span class="tit">药物管理</span>
      <div class="flex">
        <el-button @click="toDetail()" size="mini" class="addBtn">新增药物</el-button>
        <el-button @click="toCategoryList()" class="addBtn" size="mini">药物类别管理</el-button>
        <el-input class="addART"
                  placeholder="搜索药品名称" clearable
                  v-model="page.name"
                  @change="skipPage(1)"
                  suffix-icon="el-icon-search">
        </el-input>
      </div>
    </div>
    <div class="typeHead">
      <div class="medicineType flex">
        <span class="typeTit">药物类别：</span>
        <div class="medicineTypeL">
                    <span><label :class="active.categoryIndex==0?'activeClass':''"
                                 @click="change(0,0,1)">不限</label></span>
          <span v-for="(item,index) in categories" :key="index">
                            <label :class="active.categoryIndex==index+1?'activeClass':''"
                                   @click="change(index+1,item.id,1)">{{ item.cnName }}{{ item.status === 0 ? '(禁用)' : '' }}</label>
                        </span>
        </div>
      </div>
      <div class="medicineType flex">
        <span class="typeTit">适应症：</span>
        <div class="medicineTypeL">
                        <span><label :class="active.indicationIndex==0?'activeClass':''"
                                     @click="change(0,0,2)">不限</label></span>
          <span v-for="(item,index) in indications" :key="index">
                            <label :class="active.indicationIndex==index+1?'activeClass':''"
                                   @click="change(index+1,item.id,2)">
                            {{ item.cnName }}
                            </label>
                        </span>
        </div>
      </div>
    </div>
    <div class="typeCon">
      <div class="drug flex" v-for="(obj ,ind) in page.rows" :key="ind">
        <div :style="'backgroundImage: url('+obj.thumbnailPath+')'" class="img ">
          <span v-if="obj.drugType === 1">新药</span>
        </div>
        <div class="rightC">
          <h3>{{ obj.cnName }}·{{ obj.enName }}</h3>
          <p>{{ obj.briefDesc }}</p>
          <el-button size="mini" class="danger" plain @click="toDetail(obj.id)">编辑</el-button>
          <el-button size="mini" class="danger" plain @click="toDelete(obj.id)">删除</el-button>
          <el-button size="mini" class="danger" @click="changeStatus(obj)">{{ obj.status === 0 ? '隐藏中' : '展示中' }}
          </el-button>
        </div>
      </div>
      <div class="noDate flex" v-if="page.rows.length===0">暂无数据</div>
    </div>
    <el-pagination
        class="pagination"
        background
        prev-text="Prev"
        next-text="Next"
        @current-change="skipPage"
        :hide-on-single-page="true"
        :current-page="page.current"
        :page-size="page.size"
        layout="prev, pager, next"
        :total="page.total">
    </el-pagination>
  </div>
</template>

<script>
import base from '@/api/common';
import {MessageBox} from 'element-ui';

export default {
  name: "drug_list",
  data() {
    return {
      categories: [],
      indications: [],
      active: {
        categoryIndex: 0,
        indicationIndex: 0,
      },
      page: {
        current: 1,
        size: 10,
        total: 16,
        rows: [],

        category: '',
        indication: '',
        name: ''
      },
    }
  },
  mounted() {
    // 1.load category
    this.$ajax.post(base.api.drug.edit.category.list).then((res) => {
      if (res.data.status === 'success') {
        this.categories = res.data.list;
      }
    });

    // 2.load indication
    this.$ajax.get(base.api.indication.types.simple_all).then((res) => {
      if (res.data.status === 'success') {
        this.indications = res.data.list;
      }
    });

    // 3.load drugs
    this.getData();

  },
  methods: {
    getData() {
      this.$ajax.get(base.api.drug.edit.page, {
        params: {
          page: this.page.current,
          size: this.page.size,
          name: this.page.name,
          categoryId: this.page.category,
          indicationId: this.page.indication
        }
      }).then((res) => {
        if (res.data.status === 'success') {
          this.page.current = res.data.current;
          this.page.size = res.data.size;
          this.page.total = res.data.total;
          this.page.rows = res.data.rows;
        }
      });
      //document.querySelector('.homeIndex').scrollTop = 0;//回到顶部
    },
    skipPage(cur) {
      this.page.current = cur;
      this.getData();
      this.$nextTick(() => {
        $(".el-main").animate({scrollTop: '0px'}, 800);
      });
    },
    change(index, id, type) { //type: 1-category 2-indication
      this.page.current = 1; //页码重置
      if (type === 1) {
        this.active.categoryIndex = index;
        this.page.category = id;
      } else if (type === 2) {
        this.active.indicationIndex = index;
        this.page.indication = id;
      }
      this.getData();
    },
    toDetail(id) {
      if (id != null) {
        this.$router.push({name: 'drugEdit', query: {id: id}});
      } else {
        this.$router.push({name: 'drugEdit'});
      }
    },
    //去药物管理列表
    toCategoryList() {
      this.$router.push({name: 'categoryList'})
    },
    //删除药物
    toDelete(id) {
      let that = this;
      this.$confirm('如果只是想暂时下架药物,可禁用', '确认删除?', {
        confirmButtonText: '删除',
        cancelButtonText: '不删了',
        type: 'warning'
      }).then(() => {
        this.$ajax
            .post(base.api.drug.edit.delete.replace("{drugId}", id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功')
                that.getData();
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //更改药物状态
    changeStatus(item) {
      let that = this;
      let msg;
      if (item.status === 0) {
        msg = '启用'
      } else {
        msg = '禁用'
      }
      this.$confirm('是否' + msg + '?', '确认信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax
            .post(base.api.drug.edit.status.replace("{status}/{drugId}", item.status + "/" + item.id))
            .then(function (res) {
              if (res.data.status === 'success') {
                that.$message.success('操作成功')
                item.status = (item.status + 1) % 2;
              } else {
                that.$message.error(res.data.message);
              }
            }).catch((err) => {
          console.error(err);
          that.$message.error('操作失败')
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
  }
}
</script>


<style scoped lang="scss">
@import '../../../assets/css/admin.scss';

.addART {
  margin-left: 20px
}
</style>
